import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Canvas',
  attributeName: 'mainHubCanvas',
  helpText: 'This section is to control how many and what content will appear in the Room. It can be reorganized into different forms',
  fields: [
    {
      attributeName: 'canvas',
      type: FormInputTypes.CANVAS,
      label: '',
      helpText: '',
    },
  ],
};
